import * as Waves from "node-waves"

$(function () {
    Waves.init()
})
